// ----------------------------------------------------------------------------
// Component: Submit Handler
// - adapted from (http://codepen.io/asstor_/pen/MYMZZK)
//
// - when clicked, begins loading animation; displays checkmark on complete
// - should be tied into AJAX functions, ie. upon a real form submit
// ----------------------------------------------------------------------------
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var BUTTON = '.form__submit--alternate';

module.exports = function() {
    $(function() {
        $(BUTTON).click(function() {
            $(BUTTON).addClass('clicked');
            validate();
        });

        function validate() {
            setTimeout(function() {
                $(BUTTON).removeClass('clicked');
                $(BUTTON).addClass('validated');
            }, 2250);
            callback();
        }

        function callback() {
            setTimeout(function() {
                $(BUTTON).removeClass('validated');
            }, 4250);
        }
    });
};
